<template lang="pug">
  v-row.pa-5
    v-col
      inputs-list(
        :enrollment="enrollment"
        :course="course"
      )
</template>

<script>
import InputsList from '@/modules/CourseManagement/components/Enrollment/Configuration/InputsList.vue';

export default {
  components: {
    InputsList,
  },
  props: {
    enrollment: { type: Object, required: true },
    course: { type: Object, required: true },
  },
};
</script>
